import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// components
import ToolsMenu, { LinkStyled } from "core/SiteHeader/components/ToolsMenu.js";

// styles
import breakpoints from "core/breakpoints";
import { convertPxToRem } from "frontend/components/helpers";

const AsideLinksStyled = styled.div`
    flex: 0 0 48%;
    @media (min-width: ${breakpoints.desktop.rem}) {
        flex: 0 0 ${convertPxToRem(174)};
    }
    padding: ${convertPxToRem(10)} 0rem 0rem ${convertPxToRem(24)};
`;

const ToolsMenuStyled = styled(ToolsMenu)`
    display: flex;
    flex-direction: column;
    gap: ${convertPxToRem(4)};
`;

// component
export const AsideLinks = ({ linkColor, linkHoverColor }) => {
    return (
        <AsideLinksStyled>
            <ToolsMenuStyled
                linkColor={linkColor}
                linkHoverColor={linkHoverColor}
            />
        </AsideLinksStyled>
    );
};

export default AsideLinks;

// prop-types
AsideLinks.propTypes = {
    linkColor: PropTypes.string.isRequired,
    linkHoverColor: PropTypes.string.isRequired
};
